import { combineReducers } from '@reduxjs/toolkit';
import editor from './editor/editor';
import templates from './templates/templates';

const templateEditorReducer = combineReducers({
  templates: templates,
  editor: editor,
});

export default templateEditorReducer;
